import { Component, OnInit, Input, EventEmitter } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { BallotsService } from 'src/app/services/ballots.service';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Helpers } from 'src/app/helpers/helpers';
import { ActivatedRoute, Router } from '@angular/router';
import { AppComponent } from 'src/app/app.component';

@Component({
  selector: 'app-turbo-ballots-runner',
  templateUrl: './turbo-ballots-runner.component.html',
  styleUrls: ['./turbo-ballots-runner.component.scss'],
})
export class TurboBallotsRunnerComponent implements OnInit {

  // Inputs
  @Input() modalTitle: string|null = null;
  @Input() modalMode;
  @Input() modalController;
  @Input() skipBallot: EventEmitter<boolean>;

  // Internal state
  loggedUser;
  ballot;
  selected;
  matrix;
  ballotToRevealAfterVoteFromHome;
  animate = true;
  skipButtonDisabled = false;

  // Observables
  ballotObservable: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  ballotVotedObservable: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  ballotSkippedObservable: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  matrixObservable: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(
    private router: Router,
    private userService: UserService,
    private ballotsService: BallotsService,
    private route: ActivatedRoute,
    private appcomponent: AppComponent
  ) { }

  async ngOnInit() {
    this.loggedUser = await this.userService.loggedUserObservable.getValue();

    // Call 2 times to force loading from cache (first time cache is empty)
    // otherwise there was a bug that repeat first record 2 times
    await this.loadNextBallotData();
    await this.loadNextBallotData();

    // Get id of choosed ballot to reveal after vote in my ballots page
    this.route.params.subscribe(params => {
      this.ballotToRevealAfterVoteFromHome = params.ballotToReveal;
    });

    // Subscribe to skipBallot event. So can accept external requests to do it
    if (!!this.skipBallot) {
      this.skipBallot.subscribe((value) => {
        if (!!value) { this.skipTurboBallot(); }
      });
    }

    // Store next expiration_date only if is null (never set or deleted after clean)
    this.ballotObservable.subscribe((ballot) => {

    });
  }

  async loadNextBallotData() {
    this.ballot = await this.ballotsService.getTurboBallot(this.loggedUser.id);
    if (!!this.ballot === false) { return; }
    this.appcomponent.expiration_date_ballot = this.ballot.expiration_date;
    this.ballotObservable.next(this.ballot);
    this.matrix = Helpers.extractBallotMatrixToArray(this.ballot.matrix);
    this.matrixObservable.next(this.matrix);
  }

  async exchangeBallotVote(column: string) {
    this.selected = column;
    this.voteBallot(column);
  }

  async formationBallotVote(players: any) {
    this.voteBallot(JSON.stringify(players));
  }

  async purchaseBallotVote(players: any) {
    this.voteBallot(JSON.stringify(players));
  }

  async voteBallot(selection: any) {

    this.skipButtonDisabled = true;

    const voteData = {
      ballot_id: this.ballot.id,
      user_id: this.loggedUser.id,
      vote_selection: selection,
      rkanag_id: null // <- Here is always NULL because home voted are not includede in any ranking
    };

    this.ballotsService.voteBallot(voteData)
    .then(async (voteResponse) => {

      // Append ballot creator name
      voteResponse.ballot.creator = this.ballot.creator;

      // Show ballot percentages
      this.ballot = voteResponse.ballot;
      this.ballotVotedObservable.next(voteResponse.ballot);
      this.saveUpdatedUser(voteResponse.user);

      // Choose what to do after vote
      if (!!this.modalMode === false && !!this.ballotToRevealAfterVoteFromHome) {
        this.router.navigate(['my-ballots', this.ballotToRevealAfterVoteFromHome]);
      }

      // Skip ballot immediatly and exit
      if (!!this.modalMode)  {
        this.dismissModal(true);
        this.skipButtonDisabled = false;
        return;
      }

      // Skip turbo ballot after gived time
      const tSkip = setTimeout(() => {
        if (environment.dev_disableAutoskipAfterVote === false) {
          this.skipTurboBallot();
          this.skipButtonDisabled = false;
          clearTimeout(tSkip);
        }
      }, 1800);

    })
    .catch(async (error) => {
      this.skipTurboBallot();
      this.skipButtonDisabled = false;
    });
  }

  saveUpdatedUser(user) {
    if (!!user === false) { return; }
    this.userService.setLoggedUser(user);
    this.loggedUser = user;
  }

  async skipTurboBallot() {
    this.animate = false;
    this.ballotSkippedObservable.next(true);
    this.ballotVotedObservable.next(null);
    this.ballotToRevealAfterVoteFromHome = null;
    await this.loadNextBallotData();
    this.animate = true;
  }

  dismissModal(ballotVoted?) {
    this.modalController.dismiss({
      ballotVoted: (!!ballotVoted ? ballotVoted : false)
    });
  }

}
